import type { Complexity } from "./schemas.js";

const COMPLEXITY_KEYWORDS = [
  "migrate", "migration", "refactor", "integrate", "integration",
  "auth", "authentication", "authorization", "oauth",
  "real-time", "realtime", "websocket", "distributed",
  "encrypt", "security", "permission", "rbac",
  "deploy", "ci/cd", "pipeline", "infrastructure",
];

export function classifyComplexityRuleBased(description: string): Complexity {
  if (!description || description.trim().length === 0) return "S";

  let score = 0;
  const text = description.toLowerCase();

  // Length signal
  if (text.length > 500) score += 3;
  else if (text.length > 200) score += 2;
  else if (text.length > 100) score += 1;

  // Keyword density (cap at 4)
  let keywordHits = 0;
  for (const kw of COMPLEXITY_KEYWORDS) {
    if (text.includes(kw)) keywordHits++;
  }
  score += Math.min(keywordHits, 4);

  // Sentence count as scope proxy
  const sentences = text.split(/[.!?]+/).filter(s => s.trim().length > 0).length;
  if (sentences > 10) score += 2;
  else if (sentences > 5) score += 1;

  if (score <= 2) return "S";
  if (score <= 4) return "M";
  if (score <= 6) return "L";
  return "XL";
}
